<template>
    <div class="automation-block-editor sleep">
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">{{ $t('auto.sleepMode') }}</div>
            <div class="btnGroup">
                <SupsisButton
                    v-for="mode in ['duration', 'timestamp']"
                    :classNames="clone.mode === mode ? 'btnGroupItem selected' : 'btnGroupItem '"
                    :primary="clone.mode === mode"
                    :ghost="clone.mode !== mode"
                    @click="() => changeMode(mode)"
                    small
                    :key="mode"
                >
                    {{ mode }}
                </SupsisButton>
            </div>
        </div>
        <div class="editor-row customize-editor-minimize" v-if="clone.mode === 'duration'">
            <div class="editor-row-title">{{ $t('auto.sleepDuration') }}</div>
            <TiptapEditor
                placeholder="Duration"
                :show-attributes="true"
                :max-character-count="500"
                v-model="clone.duration.value"
                automation-mode
            />
        </div>
        <div class="editor-row customize-editor-minimize" v-if="clone.mode === 'timestamp'">
            <div class="editor-row-title">{{ $t('auto.sleepPickAFutureDateIsodateTimestamp') }}</div>
            <TiptapEditor
                placeholder="Timestamp"
                :show-attributes="true"
                v-model="clone.timestamp.value"
                automation-mode
            />
        </div>
        <div class="editor-row customize-editor-minimize" v-if="clone.mode === 'duration'">
            <div class="editor-row-title">{{ $t('auto.sleepUnit') }}</div>
            <CustomPicker
                v-model="clone.duration.unit"
                :items="units"
                idKey="id"
                labelKey="label"
                title="Select Duration"
            />
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import SupsisButton from "../../../../Settings/components/SupsisButton.vue";
import CustomPicker from "../../../../../../components/pickers/CustomPicker.vue";

const log = log2("Sleep");
export default {
    name: "Sleep",
    components: { CustomPicker, SupsisButton, TiptapEditor },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            mode: "duration", //duration, timestamp
            duration: {
                unit: "seconds",
                value: "1",
            },
            timestamp: {
                value: "",
            },
        };
        return {
            clone,
            units: [
                {
                    id: "seconds",
                    label: "Seconds",
                },
                {
                    id: "minutes",
                    label: "Minutes",
                },
                {
                    id: "hours",
                    label: "Hours",
                },
                {
                    id: "days",
                    label: "Days",
                },
            ],
        };
    },
    methods: {
        changeMode(mode) {
            this.clone.mode = mode;
        },
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.automation-block-editor.sleep {
    padding: 20px;
    display: flex;
    gap: 20px;
    flex-direction: column;

    section {
        width: 100%;
        display: flex;
        gap: 10px;
        flex-direction: column;
    }

    .editor-row {
        width: 100%;

        .editor-row-title {
            font-weight: bold;
            font-size: 16px;
        }
    }

    .btnGroup {
        display: flex;
        border: 1px solid var(--color-border-default);
        border-radius: 6px;
        background: var(--color-bg-neutral-default);
        margin: 2px 10px;
        padding: 2px;

        .btnGrupItem {
            &.selected {
                background: var(--color-bg-oncomponent-default);
                box-shadow: var(--shadow-interaction-200);
            }
        }

        .supsis-button {
            border: none !important;
            font-size: 13px;
            height: 25px;
        }
    }
}
</style>
